import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { CartIconComponent } from '../../../app/core/svg-icons/cart-icon.component';

const meta: Meta<CartIconComponent> = {
  title: 'Atoms/Icons/CartIcon',
  component: CartIconComponent,
  parameters: {
    docs: {
      description: {
        component: 'A shopping cart icon component. Essential for e-commerce functionality, shopping cart buttons, and cart status indicators.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<CartIconComponent>;

export const Default: Story = {
  render: () => ({
    template: '<app-cart-icon></app-cart-icon>',
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-cart-icon')).toBeTruthy();
  },
};

export const InCartButton: Story = {
  render: () => ({
    template: `
      <button class="btn btn-primary-supervin" style="display: flex; align-items: center; gap: 0.5rem;">
        <app-cart-icon></app-cart-icon>
        <span>Kurv</span>
        <span class="badge bg-light text-dark ms-2">3</span>
      </button>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Cart icon used in a shopping cart button with item count badge.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-cart-icon')).toBeTruthy();
  },
};

export const InHeader: Story = {
  render: () => ({
    template: `
      <div style="background-color: #5C0A31; padding: 1rem; color: white;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div>Supervin</div>
          <div style="display: flex; align-items: center; gap: 0.5rem; position: relative;">
            <app-cart-icon></app-cart-icon>
            <span style="position: absolute; top: -8px; right: -8px; background-color: #F39C12; color: white; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-size: 12px;">2</span>
          </div>
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Cart icon in header navigation with notification badge showing item count.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-cart-icon')).toBeTruthy();
  },
};

export const FloatingCartButton: Story = {
  render: () => ({
    template: `
      <div style="position: relative; height: 200px;">
        <button style="
          position: absolute; 
          bottom: 20px; 
          right: 20px; 
          background-color: #5C0A31; 
          color: white; 
          border: none; 
          border-radius: 50%; 
          width: 60px; 
          height: 60px; 
          display: flex; 
          align-items: center; 
          justify-content: center;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          cursor: pointer;
        ">
          <app-cart-icon></app-cart-icon>
        </button>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Cart icon as a floating action button for mobile interfaces.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-cart-icon')).toBeTruthy();
  },
};

export const CartStates: Story = {
  render: () => ({
    template: `
      <div style="display: flex; gap: 2rem; align-items: center; flex-wrap: wrap;">
        <div style="text-align: center;">
          <div>Tom kurv</div>
          <button class="btn btn-outline-secondary" style="display: flex; align-items: center; gap: 0.5rem;">
            <app-cart-icon></app-cart-icon>
            <span>Kurv (0)</span>
          </button>
        </div>
        <div style="text-align: center;">
          <div>Med varer</div>
          <button class="btn btn-primary-supervin" style="display: flex; align-items: center; gap: 0.5rem;">
            <app-cart-icon></app-cart-icon>
            <span>Kurv (3)</span>
          </button>
        </div>
        <div style="text-align: center;">
          <div>Mange varer</div>
          <button class="btn btn-primary-supervin" style="display: flex; align-items: center; gap: 0.5rem; position: relative;">
            <app-cart-icon></app-cart-icon>
            <span>Kurv</span>
            <span class="badge bg-warning text-dark">12</span>
          </button>
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Different cart states showing empty, normal, and full cart scenarios.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-cart-icon')).toBeTruthy();
  },
};
